// css
// CSS se buildí v rámci next aplikace
// import '../css-scss/main.scss';
import './windowExports';

// source
import './configureWeb';
import './configurePartialUpdate';



// WEBPACK FOOTER //
// ./fe/web-default/src/js/index.js